import { render } from "./zrdata.vue?vue&type=template&id=25c723f8&scoped=true"
import script from "./zrdata.vue?vue&type=script&lang=js"
export * from "./zrdata.vue?vue&type=script&lang=js"

import "./zrdata.vue?vue&type=style&index=0&id=25c723f8&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c723f8"]])

export default __exports__